export default "__VITE_ASSET__06c7e732__"